/* eslint-disable react/jsx-one-expression-per-line */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SchoolInfo from './SchoolInfo';

const propTypes = {
    pageTitle: PropTypes.string,
};

const PageHeader = ({ pageTitle }) => (
    <div className="page-header page-header-default">
        <div className="page-header" />
        <div
            className="breadcrumb-line"
            style={{ display: 'flex', alignItems: 'center' }}
        >
            <ul className="breadcrumb" style={{ marginBottom: 0 }}>
                <li>
                    <a href="sys_dashboard.html">
                        <i className="icon-home2 position-left" /> Trang chủ
                    </a>
                </li>

                <li className="active">{pageTitle}</li>
            </ul>
            <SchoolInfo />
        </div>
    </div>
);

PageHeader.propTypes = propTypes;

export default memo(PageHeader);
